import React, { useEffect, useState } from "react";
import styled, { css, createGlobalStyle } from "styled-components";
import Button from "../Button";
import Input from "../Input";
import ModalForm from "../ModalForm";
import { ErrorMessage, Form, Formik } from "formik";
import MessageError from "../upgraded/MessageError";
import {
  InputField,
  InputPhoneField,
  CheckboxButtonField,
} from "../upgraded/WithFormik";
import * as yup from "yup";
import HelperObj from "../../helpers/HelperObj";
import FormikNotify from "../upgraded/FormikNotify";
import { ConnectedFocusError } from "focus-formik-error";
import { useCourse } from "../../hooks/useCourse";
import ModalNotification from "../ModalNotification";

const CourseEdit = ({ courseId, isOpen = false, onClose = () => {} }) => {
  const { course, updateCheckout } = useCourse({
    courseId,
  });

  const [isSuccess, setIsSuccess] = useState(false);

  return (
    <ModalForm isOpen={isOpen} title="Pasarela de pago" onClose={onClose}>
      <ModalNotification
        type="success"
        isOpen={isSuccess}
        title="Publicado"
        description={
          <WrapperMessage>
            <Message>Se guardaron todos los datos.</Message>
          </WrapperMessage>
        }
        buttons={
          <>
            <ButtonStyled
              primary={true}
              text="Aceptar"
              onClick={() => {
                setIsSuccess(false);
                onClose();
              }}
            />
          </>
        }
      />
      <Container>
        <Formik
          enableReinitialize={true}
          initialValues={{
            videoPromotion: course.videoPromotion || "",
            priceTotal: course.priceTotal || "",
            isPromotion: course.isPromotion || false,
          }}
          validationSchema={yup.object({
            videoPromotion: yup
              .string()
              .url("No has ingresado un URL correcto.")
              .required("Es obligatorio completar este dato."),
            priceTotal: yup
              .number()
              .typeError("No has ingresado un número.")
              .positive("El precio debe ser positivo")
              .required("Es obligatorio completar este dato."),
            isPromotion: yup.boolean(),
          })}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            const valuesCleaned = HelperObj.clean(values);
            // console.log(valuesCleaned);
            updateCheckout(valuesCleaned)
              .then(() => {
                setIsSuccess(true);
              })
              .finally(() => {
                setSubmitting(false);
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            setFieldValue,
            setFieldTouched,
            submitForm,
            isSubmitting,
          }) => (
            <Form>
              <ConnectedFocusError />
              <Container>
                <InputWrapper>
                  <Label>Video promocional</Label>
                  <InputField
                    name="videoPromotion"
                    placeholder="https://www.youtube.com/watch?v=..."
                    hasError={touched.videoPromotion && errors.videoPromotion}
                  />
                  <ErrorMessage name="videoPromotion">
                    {(msg) => <MessageError messageError={msg} />}
                  </ErrorMessage>
                </InputWrapper>
                <InputWrapper>
                  <Label>Precio base</Label>
                  <InputField
                    name="priceTotal"
                    placeholder="00.00"
                    hasError={touched.priceTotal && errors.priceTotal}
                  />
                  <ErrorMessage name="priceTotal">
                    {(msg) => <MessageError messageError={msg} />}
                  </ErrorMessage>
                </InputWrapper>
                <InputWrapper>
                  <Label>Código de promoción base</Label>
                  <CheckboxButtonField
                    name="isPromotion"
                    text="SOYREBELDE"
                    hasError={touched.isPromotion && errors.isPromotion}
                  />
                  <ErrorMessage name="isPromotion">
                    {(msg) => <MessageError messageError={msg} />}
                  </ErrorMessage>
                </InputWrapper>
              </Container>

              <Footer>
                <Button text="Cancelar" secondary={true} onClick={onClose} />
                <Button
                  text="Publicar"
                  primary={true}
                  loading={isSubmitting}
                  onClick={() => {
                    submitForm();
                  }}
                />
              </Footer>
            </Form>
          )}
        </Formik>
      </Container>
    </ModalForm>
  );
};


const Container = styled.div`
  padding: 15px;
`;

const InputWrapper = styled.div`
  &:not(:last-child) {
    margin-bottom: 25px;
  }
`;

const Label = styled.div`
  margin-bottom: 15px;
`;

const Footer = styled.div`
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  width: 100%;

  & > * {
    flex: 1 0 0;
    margin: 5px;
  }

  & > *:last-child {
    flex: 2 0 0;
  }

  @media (max-width: 400px) {
    flex-direction: column-reverse;
    align-items: stretch;
  }
`;

const WrapperMessage = styled.div``;

const Message = styled.div``;

const ButtonStyled = styled(Button)`
  .button {
    background-color: #33c494;
  }
`;

export default CourseEdit;
